const ru = {
  language: { label: 'Язык' },
  nav: {
    gift: 'Подарок · 90 дней бесплатно',
    pricing: 'Тарифы и цены',
    features: 'Возможности',
    ecosystem: 'Семейная экосистема',
    clubs: 'Клубы',
    academy: 'Академия',
    lab: 'ROMIND LAB',
    safety: 'Безопасность',
    research: 'Исследования',
    insights: 'Материалы',
    about: 'О нас',
    parentSafety: 'Безопасность для родителей',
    joinTesting: 'Присоединиться к тестированию',
    contact: 'Контакты',
    toggleMenu: 'Открыть меню',
  },
  download: {
    nav: 'Скачать приложение',
    cta: 'Скачать в Google Play',
    available: 'Уже доступно',
    headline: 'ROMIND KIDS уже в Google Play!',
    description: 'Дружба, творчество и обучение в одном пространстве для детей 9–14 лет с особым вниманием к безопасности. Скачайте приложение для Android.',
    scan: 'Отсканируйте QR-код, чтобы открыть ROMIND KIDS в Google Play.',
    qrAlt: 'QR-код для скачивания ROMIND KIDS из Google Play',
  },
  footer: {
    tagline: 'Более безопасная творческая вселенная для детей 9–14 лет — и основа ROMIND Family Circle.',
    platform: 'Платформа',
    legal: 'Правовая информация',
    home: 'Главная',
    features: 'Возможности ROMIND KIDS',
    ecosystem: 'Семейная экосистема',
    clubs: 'Клубы и челленджи',
    academy: 'ROMIND Academy',
    lab: 'ROMIND LAB',
    ventureStudio: 'Venture Studio',
    safety: 'Безопасность',
    safetyResearch: 'Исследования безопасности',
    parentSafety: 'Безопасность для родителей',
    insights: 'Материалы',
    joinTesting: 'Присоединиться к тестированию',
    about: 'О нас',
    contact: 'Контакты',
    privacy: 'Политика конфиденциальности',
    terms: 'Условия использования',
    copyright: 'Пользовательский контент и авторские права',
    community: 'Правила сообщества',
    childSafetyModeration: 'Безопасность детей и модерация',
    reportHandling: 'Обработка жалоб',
    dataRetention: 'Хранение и удаление данных',
    deleteAccount: 'Удаление аккаунта',
    childSafetyOverview: 'Обзор безопасности детей',
    childSafetyResearch: 'Исследования безопасности детей',
    rights: '© 2025–2026 ROMIND KIDS — проект под управлением основателя. Все права защищены.',
    safetyPrinciples: 'Создано с учетом принципов детской безопасности',
  },
  legal: {
    eyebrow: 'Правовая информация',
    back: 'Назад к ROMIND KIDS',
    lastUpdated: 'Последнее обновление: {date}',
    operatorInfo: 'Информация об операторе:',
    otherDocs: 'Другие правовые документы и материалы по безопасности',
  },
};

export default ru;